export const metricsByTabs: Record<string, string[]> = {
  all: [],
  'pending-acquisition': [
    'number-of-customers-acquired-in-month',
  ],
  'pending-supply': [],
  invalid: [],
  expired: [],
}
